import { render, staticRenderFns } from "./collection_quality.vue?vue&type=template&id=006bebb6&scoped=true&"
import script from "./collection_quality.vue?vue&type=script&lang=js&"
export * from "./collection_quality.vue?vue&type=script&lang=js&"
import style0 from "./collection_quality.vue?vue&type=style&index=0&id=006bebb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006bebb6",
  null
  
)

export default component.exports